import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent implements OnInit {
  fileName: any;
  file: any = {
    name: '',
    size: '',
  };
  @Output() fileEmitter = new EventEmitter<any>();
  @Input() fileExist: any;
  @Input() title: string;
  @Input() icon;
  fileBandera: boolean;
  constructor() {
    this.fileBandera = false;
  }

  ngOnInit(): void {}

  open(uploader) {
    uploader.click();
  }

  fileChangeEvent(e: any) {
    console.log(e);

    this.file = e[0];
    this.fileEmitter.emit(this.file);
    if (e) {
      this.title = '';
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes.fileExist);

    if (changes.fileExist) {
      this.file = null;
    }
  }
}
